<template>
  <div class="attrib-custom-wrapper">
    <Loader :is-visible="isLoading" />

    <router-view></router-view>

    <div
      v-if="['attributions'].indexOf($route.name) > -1"
      class="animated fadeIn"
    >
      <AttributionListFilters
        :default="filters"
        :pushLoading="pushLoading"
        @applyFilters="applyFilters"
        @pushAll="pushAll"
      />
      <tabs v-model="activeTab" @input="changeTab">
        <tab :header="ordersHeader">
          <Attributions
            :attributions="orders"
            :orders="true"
            @delete="deleteAttribution"
            @moveAttribution="moveAttribution"
            @allowAttribution="allowAttribution"
            @showComment="displayComment"
          />
        </tab>
        <tab :header="notPayedHeader">
          <Attributions
            :attributions="notPayed"
            :orders="true"
            @delete="deleteAttribution"
            @moveAttribution="moveAttribution"
            @allowAttribution="allowAttribution"
            @showComment="displayComment"
          />
        </tab>
        <tab :header="paymentsHeader">
          <Attributions
            :attributions="payments"
            :payments="true"
            @delete="deleteAttribution"
            @moveAttribution="moveAttribution"
            @allowAttribution="allowAttribution"
            @showComment="displayComment"
          />
        </tab>
      </tabs>
    </div>

    <ModalSendAttribution
      :show="modalSendAttribution.show"
      :attribution="modalSendAttribution.attribution"
      :coachs="modalSendAttribution.coachs"
      @loading="(e) => (isLoading = e)"
      @close="closeModalSendAttribution"
    />

    <modal
      v-if="modalUpdateComment.commentaireOrder"
      title="Commentaire"
      v-model="modalUpdateComment.showComment"
      cancelText="Annuler"
      okText="Enregistrer"
      @ok="updateComment()"
      effect="fade/zoom"
    >
      <textarea
        v-model="modalUpdateComment.commentaireOrder.adminNotes"
        cols="30"
        rows="10"
        class="form-control form-normalization"
      >
      </textarea>
    </modal>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";
import Attributions from "@/components/attribution/Attributions";
import AttributionListFilters from "@/components/attribution/AttributionListFilters";
import Modal from "vue-strap/src/Modal";
import Loader from "@/components/utils/Loader";
import ModalSendAttribution from "@/components/attribution/ModalSendAttribution";

export default {
  components: {
    Attributions,
    AttributionListFilters,
    Tabs,
    Tab,
    Modal,
    Loader,
    ModalSendAttribution,
  },
  data() {
    return {
      filters: {
        commercials: [],
        coachManagers: [],
        type: [],
      },
      activeTab: 0,
      isLoading: false,
      pushLoading: false,
      orders: [],
      notPayed: [],
      payments: [],
      modalSendAttribution: {
        show: false,
        attribution: null,
        coachs: {},
      },
      modalUpdateComment: {
        showComment: false,
        commentaireOrder: null,
      },
    };
  },
  computed: {
    ordersHeader() {
      return `Commandes (${this.orders.length})`;
    },

    notPayedHeader() {
      return `Non payées (${this.notPayed.length})`;
    },

    paymentsHeader() {
      return `Paiements (${this.payments.length})`;
    },
  },

  async created() {
    let activeTab = sessionStorage.getItem("attributionsTab");

    if (activeTab) {
      this.activeTab = parseInt(activeTab);
    }
  },

  methods: {
    async fetchAttributions() {
      try {
        this.isLoading = true;

        const commercials = this.filters.commercials.map((c) => c.value);
        const coachManagers = this.filters.coachManagers.map((c) => c.value);

        const params = {
          commercials,
          coachManagers,
          type: this.filters.type,
        };

        const { data: ordersData } = await this.$api.get(
          "/orders/attribution",
          { params },
        );

        this.orders = ordersData.filter(
          (attr) =>
            !attr.recall &&
            !attr.isNewPayment &&
            attr.order.status !== "pending",
        );

        this.notPayed = ordersData.filter(
          (attr) => !attr.recall && attr.order.status === "pending",
        );

        this.payments = ordersData.filter(
          (attr) => attr.isNewPayment && !attr.recall,
        );
      } catch (e) {
        this.$errorToast("Impossible de charger les attributions");
      } finally {
        this.isLoading = false;
      }
    },

    deleteAttribution(attribution, type) {
      this.$confirm({
        message: "Attention, cette action est irréversible !",
        onConfirm: async () => {
          await this.$api.delete(`/attributions/${attribution.id}`, {
            data: {
              clientId: attribution.order?.refClient?.id,
              coachInQueue: attribution.coachs?.some(
                (ac) => !ac.accepted && !ac.rejected,
              ),
            },
          });

          this[type] = this[type].filter((v) => v.id !== attribution.id);
        },
      });
    },

    changeTab(index) {
      sessionStorage.setItem("attributionsTab", index);
    },

    moveAttribution(attribution) {
      if (!attribution.isNewPayment && attribution.order.status !== "pending") {
        this.orders.push(attribution);
      } else if (attribution.isNewPayment) {
        this.payments.push(attribution);
      } else if (attribution.order.status === "pending") {
        this.notPayed.push(attribution);
      } else {
        this.orders = this.orders.filter((attr) => attribution.id !== attr.id);
        this.notPayed = this.notPayed.filter(
          (attr) => attribution.id !== attr.id,
        );
        this.payments = this.payments.filter(
          (attr) => attribution.id !== attr.id,
        );
      }
    },

    pushAll() {
      let targets;
      this.pushLoading = true;

      switch (this.activeTab) {
        case 0:
          targets = this.orders;
          break;
        case 1:
          targets = this.notPayed;
          break;
      }

      this.$confirm({
        message: "Envoyer un rappel à tous les coachs qui n'ont pas répondu ?",
        onConfirm: async () => {
          for (const attribution of targets) {
            await this.$api.put(`/attributions/notification/${attribution.id}`);
          }
        },
      });

      this.pushLoading = false;
    },

    async allowAttribution(attribution) {
      this.modalSendAttribution.attribution = attribution;
      this.modalSendAttribution.show = true;

      try {
        const { data } = await this.$api.get(
          `/attributions/${attribution.id}/coachs`,
          {
            params: {
              attributionId: attribution.id,
              email: attribution.order.client,
              appli: attribution.filters?.appli ? "1" : "0",
              gender: attribution.filters?.gender || null,
              status: attribution.filters?.status || [],
              prestations: attribution.filters?.prestations || [],
              tags: attribution.filters?.tags || [],
              lang: attribution.filters?.lang || null,
              range: attribution.filters?.range ? "1" : "0",
              credit: attribution.filters?.credit || 2000,
              availability: attribution.filters?.availability ? "1" : "0",
              periods: attribution.filters?.periods || null,
            },
          },
        );

        this.modalSendAttribution.coachs = data;
      } catch (e) {
        this.modalSendAttribution.coachs = {};

        this.$errorToast("Impossible de récupérer les coachs");
      }
    },

    displayComment(order) {
      this.modalUpdateComment.showComment = true;
      this.modalUpdateComment.commentaireOrder = { ...order };
    },

    async updateComment() {
      try {
        await this.$api.put(
          "/orders/" + this.modalUpdateComment.commentaireOrder.id,
          {
            adminNotes: this.modalUpdateComment.commentaireOrder.adminNotes,
          },
        );

        this.orders = this.replaceUpdatedAttributionInArray(
          this.orders,
          this.modalUpdateComment.commentaireOrder,
        );
        this.notPayed = this.replaceUpdatedAttributionInArray(
          this.notPayed,
          this.modalUpdateComment.commentaireOrder,
        );
        this.payments = this.replaceUpdatedAttributionInArray(
          this.payments,
          this.modalUpdateComment.commentaireOrder,
        );

        this.modalUpdateComment.showComment = false;

        this.$toast.success("Note mise à jour avec succès");
      } catch (e) {
        this.$errorToast("La mise à jour de la note a échoué");
      }
    },

    replaceUpdatedAttributionInArray(array, attribution) {
      return array.map((item) => {
        if (item.orderId === attribution.id) {
          return { ...item, order: { ...item.order, ...attribution } };
        }

        return item;
      });
    },

    async applyFilters(form) {
      this.filters = {
        ...this.filters,
        ...form,
      };

      await this.fetchAttributions();
    },

    closeModalSendAttribution() {
      this.modalSendAttribution.show = false;
      this.modalSendAttribution.attribution = null;
      this.modalSendAttribution.coachs = {};
    },
  },
};
</script>

<style lang="css">
/*[TODO] May we improved */
.attrib-custom-wrapper {
  max-width: calc(100vw - 320px);
}

@media (max-width: 991px) {
  .attrib-custom-wrapper {
    max-width: calc(100vw - 70px);
  }
}

.aside-menu-fixed.sidebar-hidden .attrib-custom-wrapper {
  max-width: calc(100vw - 70px);
}
</style>
